import { gql } from '@apollo/client'

const storeOrderFragment = gql`
  fragment storeOrderFragment on Order {
    _id
    summary
    code
    status
    activeConversationId
    updatedAt
    createdAt
    net
    by {
      _id
      profile {
        _id
        name
        picture
        email
      }
      status
      company {
        _id
        name
      }
      address {
        _id
        street1
        street2
        city
        state
        zip
        fullAddress
        country
      }
      addresses {
        _id
        street1
        street2
        city
        state
        zip
        fullAddress
        country
        status
      }
    }
    items {
      _id
      product {
        _id
        code
        name
        coverImage
        coverImageThumb
        status
        inventory {
          _id
          quantityOnHand
        }
      }
      quantity
      price
      net
      remarks
      tags
      uom {
        _id
        code
        name
        symbol
      }
    }
    shippingFee
    gross
    remarks
    tags
    taxAmount
    discount
    paymentStatus
    paymentBalance {
      balance
      _id
    }

    payments {
      _id
      status
      date
      method
      remarks
      stripeInfo {
        _id
        paymentIntent
        paymentId
      }
    }
    communication {
      _id
      email {
        _id
        to
        from
        timeStamp
        content
      }
    }
    shipping {
      _id
      status
      shipmentId
      amount
      shippingCost
      insuranceCost
      date
      trackingNumber
      trackingUrl
      pdfLabel
      pngLabel
      zplLabel
      pickupId
      pickupWindowStartDate
      pickupWindowEndDate
      pickupNotes
      pickupCancelledDate
      isVoidLabel
      voidMessage
      rate {
        _id
        deliveryDays
        estimatedDeliveryDate
        serviceType
        carrierName
      }
      labelId
      billToCustomer
      billToAccount
      billToPostalCode
      billToCountryCode
      packages {
        _id
        tracking_number
        trackingUrl
      }
    }
    shippingAddress {
      _id
      street1
      street2
      city
      state
      zip
      country
      fullAddress
    }
    billingAddress {
      _id
      street1
      street2
      city
      state
      zip
      country
      fullAddress
    }
    customerPoNumber
    allItemsInStock
    isManualShippingRate
    allowPrePayment
    invoiceNotes
  }
`

export const singleOrderQuery = gql`
  ${storeOrderFragment}
  query singleOrder($filter: JSON) {
    singleOrder(filter: $filter) {
      ...storeOrderFragment
    }
  }
`

export const getMyStoreOrderQuery = gql`
  ${storeOrderFragment}
  query getMyOrder($filter: JSON) {
    getMyOrder(filter: $filter) {
      ...storeOrderFragment
    }
  }
`

export const myOrderIdListQuery = gql`
  query getMyOrderList($filter: JSON, $options: JSON) {
    getMyOrderList(filter: $filter, options: $options) {
      _id
      createdAt
    }
    getMyOrderListMeta(filter: $filter) {
      count
    }
  }
`
